module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Vorgeschlagen.518176eb.svg";